// extracted by mini-css-extract-plugin
export var connectionButton = "_b8-1";
export var rightPanel = "_b8-3";
export var stepDescription = "_b8-2";
export var stepIcon = "_b8-0";